import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#DA7756',      // Tailwind primary.500
      dark: '#c66a4d',      // Tailwind primary.600
      light: '#e8a58e',     // Tailwind primary.300
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#8b8475',      // Tailwind secondary.500
    },
    background: {
      default: '#f7f7f7',   // Tailwind background.DEFAULT
      paper: '#faf9f7',     // Tailwind cream
    },
    error: { main: '#ef4444' },
    success: { main: '#22c55e' },
    warning: { main: '#f59e0b' },
    info: { main: '#3b82f6' },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
    h1: {
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    subtitle1: {
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '0.8125rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    caption: {
      fontSize: '0.6875rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    overline: {
      fontSize: '0.625rem',
      fontWeight: 600,
      lineHeight: 1.4,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.08em',
    },
    button: {
      fontSize: '0.8125rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { fontSize: '0.75rem', padding: '8px 12px' },
        head: { fontWeight: 600 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontSize: '0.6875rem' },
        sizeSmall: { fontSize: '0.625rem' },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: { fontSize: '0.8125rem' },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { fontSize: '0.8125rem' },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { fontSize: '0.8125rem' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { fontSize: '0.8125rem', textTransform: 'none' },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '0.6875rem' },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { fontSize: '0.8125rem' },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: { fontSize: '0.8125rem' },
        secondary: { fontSize: '0.6875rem' },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        li: { fontSize: '0.75rem' },
      },
    },
  },
});
